module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-head"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/OEBPS/toc#ilust"
    }
  }, [_vm._v("LIST OF ILLUSTRATIONS")])])]), _vm._v(" "), _c('h2', {
    staticClass: "head2"
  }, [_c('strong', [_vm._v("1st section")])]), _vm._v(" "), _c('p', {
    staticClass: "illus"
  }, [_c('em', [_vm._v("Solomon and the Queen of Sheba")]), _vm._v(", Hans Holbein the Younger, c.1534. (The Royal Collection © 2000, Her Majesty the Queen Elizabeth II.)")]), _vm._v(" "), _c('p', {
    staticClass: "illus"
  }, [_c('em', [_vm._v("The Field of Cloth of Gold")]), _vm._v(" (at Hampton Court), artist unknown. (The Royal Collection © 2000, Her Majesty the Queen Elizabeth II.)")]), _vm._v(" "), _c('p', {
    staticClass: "illus"
  }, [_vm._v("‘The King’ and ‘The Pope’ from "), _c('em', [_vm._v("The Dance of Death")]), _vm._v(", Hans Holbein, c. 1523–6.")]), _vm._v(" "), _c('p', {
    staticClass: "illus"
  }, [_c('em', [_vm._v("Henry VIII")]), _vm._v(", c.1537, after Hans Holbein. (Walker Art Gallery, National Museums & Galleries on Merseyside.)")]), _vm._v(" "), _c('p', {
    staticClass: "illus"
  }, [_c('em', [_vm._v("Thomas Howard, 3rd Duke of Norfolk")]), _vm._v(", 1540, Hans Holbein. (The Royal Collection © 2000, Her Majesty the Queen Elizabeth II.)")]), _vm._v(" "), _c('p', {
    staticClass: "illus"
  }, [_c('em', [_vm._v("Cardinal Thomas Wolsey")]), _vm._v(" as founder of Cardinal (later Christ Church) College, Oxford, Sampson Strong. (Christ Church College, Oxford.)")]), _vm._v(" "), _c('p', {
    staticClass: "illus"
  }, [_vm._v("Effigy of Bishop Wainfleet in Winchester Cathedral. (The Dean and Chapter of Winchester.)")]), _vm._v(" "), _c('p', {
    staticClass: "illus"
  }, [_c('em', [_vm._v("Christina of Denmark, Duchess of Milan")]), _vm._v(", 1538, Hans Holbein. (National Gallery, London.)")]), _vm._v(" "), _c('h2', {
    staticClass: "head2"
  }, [_c('strong', [_vm._v("2nd section")])]), _vm._v(" "), _c('p', {
    staticClass: "illus"
  }, [_c('em', [_vm._v("Thomas More")]), _vm._v(", 1527, Hans Holbein. (Copyright The Frick Collection, New York.)")]), _vm._v(" "), _c('p', {
    staticClass: "illus"
  }, [_c('em', [_vm._v("Henry VIII, King of England")]), _vm._v(" (with his daughter Princess Mary and William Somers, the Jester), Hans Holbein. (Hulton Getty.)")]), _vm._v(" "), _c('p', {
    staticClass: "illus"
  }, [_c('em', [_vm._v("Anne de Clèves, reine d’Angleterre")]), _vm._v(", 1539, Hans Holbein. (Photo RMN.)")]), _vm._v(" "), _c('p', {
    staticClass: "illus"
  }, [_c('em', [_vm._v("A Lady: Portrait of an Unknown Lady")]), _vm._v(" (inscribed Anna Bollein Queen), c.1530, Hans Holbein. (The Royal Collection © 2000, Her Majesty the Queen Elizabeth II.)")]), _vm._v(" "), _c('p', {
    staticClass: "illus"
  }, [_c('em', [_vm._v("The Light of the World")]), _vm._v(", Hans Holbein.")]), _vm._v(" "), _c('p', {
    staticClass: "illus"
  }, [_vm._v("German woodcut of the deluge, 1524.")]), _vm._v(" "), _c('p', {
    staticClass: "illus"
  }, [_c('em', [_vm._v("Thomas Cromwell, 1st Earl of Essex")]), _vm._v(", c.1530, after Hans Holbein. (By courtesy of the National Portrait Gallery, London.)")]), _vm._v(" "), _c('p', {
    staticClass: "illus"
  }, [_vm._v("Cranmer plucked from the pulpit, 1569. (Bodleian Library, Oxford.)")]), _vm._v(" "), _c('p', {
    staticClass: "illus"
  }, [_c('em', [_vm._v("Thomas Wriothesley")]), _vm._v(", c.1535, Hans Holbein. (Courtesy of the Musées Nationaux, Paris.)")]), _vm._v(" "), _c('p', {
    staticClass: "illus"
  }, [_c('em', [_vm._v("Thomas Cranmer")]), _vm._v(", c.1550, artist unknown. (Lambeth Palace.)")]), _vm._v(" "), _c('p', {
    staticClass: "illus"
  }, [_vm._v("Title page of Coverdale’s Bible, 1535, Hans Holbein. (The British Library.)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7890bbc6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ilust.vue
// module id = 75
// module chunks = 0